export default {
  increment (state) {
    state.testCount++
  }
};
